import { RouteConfig } from "vue-router";

export const partnerRoutes: Array<RouteConfig> = [
  {
    path: ``,
    name: "Partner Companies",
    component: () => import("@/views/partners/overview/index.vue"),
  },
];
